export enum NewsletterRecipientOrigin {
  RegisteredUser = 0,
  GuestBuyer = 1,
  WebsiteForm = 2,
  Import = 3,
  /** A member of a service mail's audience list (PAUL-3689); never a newsletter's. */
  AudienceMember = 4,
}

export const newsletterRecipientOriginTranslations: Record<NewsletterRecipientOrigin, string> = {
  [NewsletterRecipientOrigin.RegisteredUser]: 'newsletter.recipients.origin.registered',
  [NewsletterRecipientOrigin.GuestBuyer]: 'newsletter.recipients.origin.guest',
  [NewsletterRecipientOrigin.WebsiteForm]: 'newsletter.recipients.origin.website',
  [NewsletterRecipientOrigin.Import]: 'newsletter.recipients.origin.import',
  [NewsletterRecipientOrigin.AudienceMember]: 'newsletter.recipients.origin.audience_member',
};

/** The origins a newsletter's recipients can have; a service mail's all share AudienceMember. */
export const newsletterRecipientOriginOptions = [
  {
    text: newsletterRecipientOriginTranslations[NewsletterRecipientOrigin.RegisteredUser],
    val: NewsletterRecipientOrigin.RegisteredUser,
  },
  {
    text: newsletterRecipientOriginTranslations[NewsletterRecipientOrigin.GuestBuyer],
    val: NewsletterRecipientOrigin.GuestBuyer,
  },
  {
    text: newsletterRecipientOriginTranslations[NewsletterRecipientOrigin.WebsiteForm],
    val: NewsletterRecipientOrigin.WebsiteForm,
  },
  {
    text: newsletterRecipientOriginTranslations[NewsletterRecipientOrigin.Import],
    val: NewsletterRecipientOrigin.Import,
  },
];
